import React, { PureComponent } from 'react';
import MusicGrid from '../../components/MusicGrid';
import Placeholder from '../../containers/Placeholder';
import PlaylistsFilter from '../../components/PlaylistsFilter';
import RibbonsUtil from '../../utils/RibbonsUtil';
import logger from 'src/utils/logger/logger';

class Playlist extends PureComponent {
    constructor(props) {
        super(props);
        this.onSelectFilter = this.onSelectFilter.bind(this);
        this.getList = this.getList.bind(this);
        this.state = {
            isFetching: true,
            common: null,
            seasons: null,
            purchaseButtonInfo: null,
            user: props.user,
            playlists: [],
            showPlaceholder: false,
            content: props.content,
            start: 0,
            size: 30,
            category: 'general'
        };
    }

    componentDidMount() {
        this.getList();
    }

    getList() {
        const { setIsFetching, tab } = this.props;
        const { user, start, size, category } = this.state;
        let { playlists } = this.state;
        const musicRb = new RibbonsUtil();

        const services =
            tab === 1
                ? 'ribbons'
                : tab === 2
                ? 'level'
                : tab === 3
                ? 'userPlaylist'
                : 'followedPlaylists';
        const data =
            tab === 1
                ? {
                      filter: 'general'
                  }
                : { start, size, category };
        this.setState({ isFetching: true });
        setIsFetching(true);

        const addIsFollowingToItem = arr =>
            arr.map(it => {
                it.isFollowing = false;
                return it;
            });

        const deleteIsFollowingToItem = arr =>
            arr.map(it => {
                delete it.isFollowing;
                return it;
            });

        const returnTheSameArray = arr => arr;

        const parseFunciton =
            tab === 1 || tab === 2
                ? addIsFollowingToItem
                : tab === 3
                ? deleteIsFollowingToItem
                : returnTheSameArray;
        musicRb
            .getListFromApi(services, user, data)
            .then(resp => {
                const { components } = resp.response;
                if (tab === 2 || (tab === 4 && playlists.length > 0)) {
                    playlists = [].concat(playlists, parseFunciton(components[1].items));
                } else {
                    playlists = parseFunciton(components[1].items);
                }
                this.setState({
                    playlists,
                    start: start + size,
                    isFetching: false,
                    showPlaceholder: !(playlists.length > 0) || playlists.length === 0
                });
                setIsFetching(false);
            })
            .catch(err => {
                logger.error('Playlist:' + err);
                this.setState({
                    isFetching: false,
                    showPlaceholder: true
                });
                setIsFetching(false);
            });
    }

    onSelectFilter(category) {
        this.setState(
            {
                start: 0,
                size: 30,
                category: category.genreAlias,
                playlists: []
            },
            () => {
                this.getList();
            }
        );
    }

    render() {
        const { showPlaceholder, content, playlists } = this.state;
        const { user, onFocusCardHandler, tab } = this.props;
        return (
            <div>
                {tab === 2 && <PlaylistsFilter user={user} onSelectFilter={this.onSelectFilter} />}
                {!showPlaceholder && (
                    <MusicGrid
                        items={playlists}
                        onFocusHandler={onFocusCardHandler}
                        gridType="playlist"
                        getMore={this.getList}
                        musicClass={tab === 2 ? 'playlists-recommended' : ''}
                    />
                )}
                {showPlaceholder && (
                    <Placeholder type={content} onFocusHandler={onFocusCardHandler} />
                )}
            </div>
        );
    }
}

export default Playlist;



// WEBPACK FOOTER //
// ./src/components/Playlist/index.jsx